import { Chip, CircularProgress, formatNumber, Stack, Typography } from 'ui';

import type { NetTakeRate } from '~/matching/types';

const TARGET_MARGIN_TOLERANCE = 0.02;

export const NetTakeRateOverview = ({
  totalNetTakeRate,
  targetMargin,
}: {
  totalNetTakeRate?: NetTakeRate;
  targetMargin?: number;
}) => {
  return (
    <Stack gap={2} alignItems="center" direction="row" justifyContent="space-between">
      <Typography fontWeight="bold" variant="body2" noWrap>
        Resulting NTR:
      </Typography>

      {totalNetTakeRate?.isLoading ? (
        <CircularProgress size={24} />
      ) : !totalNetTakeRate ? (
        <Chip color="default" label="-" />
      ) : (
        <Chip
          color={
            totalNetTakeRate.rate && totalNetTakeRate.rate >= (targetMargin || 0) - TARGET_MARGIN_TOLERANCE
              ? 'success'
              : 'error'
          }
          label={
            totalNetTakeRate.rate
              ? formatNumber(totalNetTakeRate.rate, {
                  minimumFractionDigits: 2,
                  style: 'percent',
                })
              : totalNetTakeRate.error?.toString() || '-'
          }
        />
      )}
    </Stack>
  );
};
